module.exports = __webpack_public_path__ + "static/Slide-hero-6eebd43aafbc77f5f7bbed1391b7aa32.png";